import React from "react";
import { useNavigate } from "react-router-dom";

import calendarIcon from '../../../assets/icons/calendar.svg';
import placeholderImage from '../../../assets/images/noimage.png';
import formatDate from '../../../utils/formatDate';

function NewItem(props) {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/news/${props.service}/${props.id}`);
    };

    const getImageSrc = () => {
        if (!props.file) return placeholderImage;
        const f = props.file;
        if (f.startsWith('data:')) return f;
        if (f.startsWith('http://') || f.startsWith('https://')) return f;
        return `data:image/jpeg;base64,${f}`;
    };

    return (
        <div
            className="cursor-pointer bg-white rounded-[10px] flex flex-col w-full overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            onClick={handleClick}
        >
            <div className="relative w-full aspect-[4/3] bg-gray-100">
                <img
                    className="w-full h-full object-cover"
                    src={getImageSrc()}
                    alt={props.name || 'Жаңалық'}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = placeholderImage;
                    }}
                />
            </div>
            <div className="p-4 flex flex-col gap-2">
                <p className="font-medium text-[#222222] text-base m-0 line-clamp-2">
                    {props.name}
                </p>
                <div className="flex items-center gap-2 text-sm text-[#666]">
                    <img src={calendarIcon} alt="" className="w-4 h-4 flex-shrink-0" />
                    <span>{formatDate(props.date)}</span>
                </div>
            </div>
        </div>
    );
}

export default NewItem;
